import { Moon, Sun, LogOut, User } from 'lucide-react';
import { useClerk, useUser } from '@clerk/clerk-react';
import { useTheme } from '../contexts/ThemeContext';
import { useAdmin } from '../contexts/AdminContext';
import Badge from './Badge';

export default function Header() {
    const { theme, toggleTheme } = useTheme();
    const { signOut } = useClerk();
    const { user } = useUser();
    const { admin, isSuperAdmin } = useAdmin();

    const handleSignOut = async () => {
        await signOut();
    };

    return (
        <header className="h-16 border-b border-border-light dark:border-border-dark px-6 flex items-center justify-between bg-background-light dark:bg-background-dark">
            <div className="flex items-center gap-4">
                <h2 className="text-lg font-semibold">Admin Panel</h2>
            </div>

            <div className="flex items-center gap-4">
                {/* Theme Toggle */}
                <button
                    onClick={toggleTheme}
                    className="p-2 rounded-lg hover:bg-accent-light dark:hover:bg-accent-dark transition-colors"
                    title="Toggle theme"
                >
                    {theme === 'light' ? <Moon size={20} /> : <Sun size={20} />}
                </button>

                {/* User Info */}
                <div className="flex items-center gap-3 px-3 py-2 rounded-lg bg-accent-light dark:bg-accent-dark">
                    <div className="flex items-center gap-2">
                        <User size={20} />
                        <div className="flex flex-col items-start">
                            <span className="text-sm font-medium">
                                {user?.primaryEmailAddress?.emailAddress}
                            </span>
                            {isSuperAdmin() && (
                                <Badge variant="danger" className="text-xs">
                                    Super Admin
                                </Badge>
                            )}
                        </div>
                    </div>
                </div>

                {/* Sign Out */}
                <button
                    onClick={handleSignOut}
                    className="p-2 rounded-lg hover:bg-accent-light dark:hover:bg-accent-dark transition-colors text-red"
                    title="Sign out"
                >
                    <LogOut size={20} />
                </button>
            </div>
        </header>
    );
}

